import type { VariantProps } from "class-variance-authority";
import type { badgeVariants } from "@/components/ui/badge";

type BadgeVariant = NonNullable<VariantProps<typeof badgeVariants>["variant"]>;

// Matches the per-status colors on the audit Kanban board (COLUMN_COLORS in
// AuditKanban.tsx: purple/slate/blue/emerald/red) so a status reads the same
// color wherever it's shown.
export const AUDIT_STATUS_LABELS: Record<string, string> = {
  assigned: "Assigned",
  guidance_requested: "Guidance Requested",
  in_progress: "In Progress",
  complete: "Complete",
  blocked: "Blocked",
};

export const AUDIT_STATUS_BADGE_VARIANTS: Record<string, BadgeVariant> = {
  assigned: "slate",
  guidance_requested: "purple",
  in_progress: "blue",
  complete: "success",
  blocked: "red",
};

// Statuses considered "active" (not yet complete) — an audit is still active
// while it's blocked, since blocked just means work is paused, not finished.
export const ACTIVE_AUDIT_STATUSES = [
  "assigned",
  "guidance_requested",
  "in_progress",
  "blocked",
] as const;
